exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-container{margin-top:0.05208rem;position:relative}.editor-container .ck-editor__main .ck-content{height:calc(100vh - 0.4375rem - 0.28125rem - 0.3125rem - 0.39583rem)}.is-hide{position:absolute;z-index:-1;top:0;left:0;opacity:0}.editor-loading{position:absolute;top:0;width:100%;height:100%;z-index:99999;display:flex;align-items:center;justify-content:center}\n", ""]);

// exports
